import { CatalogProductsTestIds } from '../../../../../../utils/testIds/CatalogProducts.testIds';
import ProductDetailsAddOrderButtonV2 from '../../../../../products/products-details-v2/ProductDetailsAddOrderButtonV2';
import {
  CatalogListAddOrderButtonProps,
  useCatalogListAddOrderButton,
} from '../hooks/useCatalogListAddOrderButton';

const CatalogListAddOrderButton = (props: CatalogListAddOrderButtonProps) => {
  const { isDisabled, gridButtonStatus, tooltipMessage, onAdd, onRemove } =
    useCatalogListAddOrderButton(props);

  return (
    <ProductDetailsAddOrderButtonV2
      disabled={isDisabled}
      gridButtonStatus={gridButtonStatus}
      combinationKey={props.combination.combinationKey}
      tooltipMessage={tooltipMessage}
      testId={CatalogProductsTestIds.PRODUCT_ADD_BUTTON}
      onAdd={onAdd}
      onRemove={onRemove}
    />
  );
};

export default CatalogListAddOrderButton;
